import { atom } from 'jotai';

/** In-memory only — persists across the page session, not reloads. */
export const voiceFeedbackSubmittedAtom = atom(false);

export const voiceFeedbackMarkSubmittedAtom = atom(null, (_get, set) => {
  set(voiceFeedbackSubmittedAtom, true);
});
